<script lang="ts">
    import { getDBEntry } from "../../../api"
    import OrderTitleRow from "./OrderTitleRow.svelte"
    import TaskTitleRow from "./TaskTitleRow.svelte"

    export let task: TaskOilSpillRemoval | TaskTowing
    let order: Order

    getDBEntry("order", { _id: task.orderId }).then((response) => {
        order = response
    })
</script>

<div class="lower">
    {#if order}
        <OrderTitleRow order="{order}" />
    {/if}
    <TaskTitleRow task="{task}" />
</div>

<style lang="less">
    @import "../../../../assets/variables.less";
    .lower {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        @media @mobile {
            flex-direction: column;
        }
    }
</style>
